var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login_R_Form"},[_c('Editor',{attrs:{"form":_vm.form},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }